import { useCallback, useState, useEffect, useRef } from 'react';

export const useTableChange = ({ initSortedInfo, initFilteredInfo } = {}) => {
  const hasChangeRef = useRef(false);

  const [sortedInfo, setSortedInfo] = useState(initSortedInfo || null);
  const [filteredInfo, setFilteredInfo] = useState(initFilteredInfo || null);

  const handleTableChange = useCallback((_pagination, filters, sorter) => {
    hasChangeRef.current = true;
    setSortedInfo(sorter);
    setFilteredInfo(filters);
  }, []);

  useEffect(() => {
    if (!hasChangeRef.current) {
      setSortedInfo(initSortedInfo);
    }
  }, [initSortedInfo]);

  useEffect(() => {
    if (!hasChangeRef.current) {
      setFilteredInfo(initFilteredInfo);
    }
  }, [initFilteredInfo]);

  return { sortedInfo, filteredInfo, handleTableChange };
};
